// import * as THREE from 'three';

export interface ExtendedMesh extends THREE.Mesh {
    init?: THREE.Vector3;
    iconName?: string;
    trackerId?: string;
    options?: any;
    offsetAxis?: string;
    lookAtType?: 'ROTATE_2D' | 'ROTATE_3D' | 'ROTATE_2D_CONSTRAINT' | 'ROTATE_3D_CONSTRAINT';
}

export function createExtendedMesh(geometry?: THREE.Geometry, material?: THREE.Material): ExtendedMesh {
    const mesh = new THREE.Mesh(geometry, material);

    // Propriétés personnalisées
    // mesh.init = new THREE.Vector3(0, 0, 0);
    // mesh.iconName = '';
    // mesh.trackerId = '';
    // mesh.options = {};
    // mesh.offsetAxis = 'z';
    // mesh.lookAtType = 'ROTATE_2D';

    // // S'assurer que la géométrie a les propriétés legacy THREE.js
    // if (mesh.geometry && !mesh.geometry.vertices) {
    //     mesh.geometry.vertices = [];
    //     mesh.geometry.verticesNeedUpdate = false;
    // }

    return mesh;
}

